import { IConfigContextProps } from '@eventbrite/auth-lib';
import { dangerousGettext, gettext } from '@eventbrite/i18n';
import { SIGN_IN_PATH } from '../../../shared/constants';

export const getSocialSignupConfiguration = ({
    request,
    gaSettings,
    captcha,
    socialSSOSettings,
    fp,
    featureFlags,
    onAttempt,
    onSuccess,
    onError,
}: {
    request: any;
    gaSettings: any;
    captcha: any;
    socialSSOSettings: any;
    fp: any;
    featureFlags: any;
    onAttempt?: () => void;
    onSuccess?: (response: any) => void;
    onError?: ({ title, message }: { title: string; message: string }) => void;
}): IConfigContextProps => {
    const _request = { ...request };

    return {
        socialMethods: {
            attempt: () => {
                onAttempt && onAttempt();
            },
            success: (response: any) => {
                onSuccess && onSuccess(response);
            },
            error: {
                ['EXTERNAL_USER_EMAIL_ALREADY_USED']: () => {
                    onError &&
                        onError({
                            title: gettext('Email already exists').toString(),
                            message: dangerousGettext(
                                'This email is already associated with an Eventbrite account. Please <a href="%(signInPath)s" target="_self">log in</a> or use a different email address.',
                                {
                                    signInPath: SIGN_IN_PATH,
                                },
                            ).toString(),
                        });
                },
                ['EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT']: () => {
                    onError &&
                        onError({
                            title: gettext('Email already exists').toString(),
                            message: dangerousGettext(
                                'This email is already associated with an Eventbrite account. Please <a href="%(signInPath)s" target="_self">log in</a> or use a different email address.',
                                {
                                    signInPath: SIGN_IN_PATH,
                                },
                            ).toString(),
                        });
                },
                default: () => {
                    onError &&
                        onError({
                            title: gettext(
                                'Sorry, something went wrong.',
                            ).toString(),
                            message: gettext('Please try again.').toString(),
                        });
                },
            },
        },
        analytics: {
            request: _request,
            gaSettings,
        },
        captcha,
        request: _request,
        social: {
            SSOSettings: socialSSOSettings,
            disabledOptions: ['apple'],
        },
        featureFlags,
        fp,
    };
};
